import { produce } from "immer";
import {
  SET_VIEW,
  SET_VIEW_MONTH,
  SET_VIEW_YEAR,
  SET_YEAR,
  TOGGLE_ALLOWANCE,
  TOGGLE_LEAVE,
  TOGGLE_VIEW,
  TOGGLE_APPROVE,
  TOGGLE_HISTORY,
  //
  ADD_LEAVE,
  ADD_LEAVE_SUCCESS,
  ADD_LEAVE_FAILURE,
  PREVIEW_ANNUAL_LEAVE,
  PREVIEW_ANNUAL_LEAVE_SUCCESS,
  PREVIEW_ANNUAL_LEAVE_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  FETCH_LEAVE,
  FETCH_LEAVE_SUCCESS,
  FETCH_LEAVE_FAILURE,
  //
  SET_ALLOWANCE,
  SET_ALLOWANCE_SUCCESS,
  SET_ALLOWANCE_FAILURE,
  //
  DELETE_LEAVE,
  DELETE_LEAVE_SUCCESS,
  DELETE_LEAVE_FAILURE,
  //
  EDIT_LEAVE,
  EDIT_LEAVE_SUCCESS,
  EDIT_LEAVE_FAILURE,
  //
  GET_YEARS,
  GET_YEARS_SUCCESS,
  GET_YEARS_FAILURE,
  //
  FETCH_HISTORY,
  FETCH_HISTORY_SUCCESS,
  FETCH_HISTORY_FAILURE,
  //
  FETCH_REQUESTS,
  FETCH_REQUESTS_SUCCESS,
  FETCH_REQUESTS_FAILURE,
  //
  APRROVE_LEAVE,
  APRROVE_LEAVE_SUCCESS,
  APRROVE_LEAVE_FAILURE,
  //
  FETCH_MONTH,
  FETCH_MONTH_SUCCESS,
  FETCH_MONTH_FAILURE,
  //
  GET_HISTORY,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAILURE,
  //
  GET_HOME_LEAVES,
  GET_HOME_LEAVES_SUCCESS,
  GET_HOME_LEAVES_FAILURE,
  //
  UPDATE_LEAVE_EMP,
  //
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILURE,
  TOGGLE_FILE_DEL,
  //
  FETCH_REPORT_LIST,
  FETCH_REPORT_LIST_SUCCESS,
  FETCH_REPORT_LIST_FAILURE,
  //
  GET_ACCRUAL_LEAVE,
  GET_ACCRUAL_LEAVE_SUCCESS,
  GET_ACCRUAL_LEAVE_FAILURE,
  //
  GET_ACCRUAL_PERIOD,
  GET_ACCRUAL_PERIOD_SUCCESS,
  GET_ACCRUAL_PERIOD_FAILURE,
  //
  EXPORT_ACCRUAL,
  EXPORT_ACCRUAL_SUCCESS,
  EXPORT_ACCRUAL_FAILURE,
  //
  GET_AVG_HOURS,
  GET_AVG_HOURS_SUCCESS,
  GET_AVG_HOURS_FAILURE,
} from "./constants";
import { getYear } from "../../utils/dates";

export const initialState = {
  view: "default", // default, days
  viewMonth: 1,
  viewYear: getYear(),
  year: getYear(),
  allowanceDrawer: {
    open: false,
    data: null,
  },
  leaveModal: {
    open: false,
    data: null,
  },
  isAddingLeave: false,
  isPreviewingAnnualLeave: false,
  isEditingLeave: false,
  isGettingData: false,
  //
  isFetchingLeave: false,
  leaves: [],
  //
  viewModal: {
    open: false,
  },
  isDeletingLeave: false,
  //
  isFetchingYears: false,
  yearList: [],
  //
  isFetchingHistory: false,
  leaveHistory: [],
  //
  isFetchingReqs: false,
  requestList: [],
  //
  approveModal: {
    open: false,
  },
  historyModal: {
    open: false,
  },
  singleHistory: {},
  //
  isFetchingHome: false,
  homeLeaves: [],
  //
  leaveEmployee: {},
  deletingData: {
    isDeleting: false,
    id: "",
  },
  deleteFileConfirm: {
    open: false,
  },
  isFetchingReportList: false,
  reportList: [],
  //
  isFetchingAccrualLeave: false,
  accrualLeave: {},
  //
  isFetchingAccrualPeriod: false,
  accrualPeriod: [],
  //
  isExportingAccrual: false,
  //
  isFetchingAvgHours: false,
  avgHours: {},
};

const LeaveReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_VIEW:
        draft.view = action.payload;
        break;

      case SET_VIEW_MONTH:
        draft.viewMonth = action.payload;
        break;

      case SET_VIEW_YEAR:
        draft.viewYear = action.payload;
        break;

      case SET_YEAR:
        draft.year = action.payload;
        break;

      case TOGGLE_ALLOWANCE:
        draft.allowanceDrawer = action.payload;
        break;

      case TOGGLE_LEAVE:
        draft.leaveModal = action.payload;
        break;

      case TOGGLE_APPROVE:
        draft.approveModal = action.payload;
        break;

      case TOGGLE_VIEW:
        draft.viewModal = action.payload;
        break;

      case TOGGLE_HISTORY:
        draft.historyModal = action.payload;
        break;

      case ADD_LEAVE:
        draft.isAddingLeave = true;
        break;
      case ADD_LEAVE_SUCCESS:
        draft.isAddingLeave = false;
        break;
      case ADD_LEAVE_FAILURE:
        draft.isAddingLeave = false;
        break;
      case PREVIEW_ANNUAL_LEAVE:
        draft.isPreviewingAnnualLeave = true;
        break;
      case PREVIEW_ANNUAL_LEAVE_SUCCESS:
        draft.isPreviewingAnnualLeave = false;
        break;
      case PREVIEW_ANNUAL_LEAVE_FAILURE:
        draft.isPreviewingAnnualLeave = false;
        break;

      case EDIT_LEAVE:
        draft.isEditingLeave = true;
        break;
      case EDIT_LEAVE_SUCCESS:
        draft.isEditingLeave = false;
        draft.view = `default`;
        break;
      case EDIT_LEAVE_FAILURE:
        draft.isEditingLeave = false;
        draft.view = `default`;
        break;

      case GET_VIEW_DATA:
        draft.isGettingData = true;
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isGettingData = false;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isGettingData = false;
        break;

      case FETCH_LEAVE:
        draft.isFetchingLeave = true;
        draft.leaves = [];
        break;
      case FETCH_LEAVE_SUCCESS:
        draft.isFetchingLeave = false;
        draft.leaves = action.payload;
        break;
      case FETCH_LEAVE_FAILURE:
        draft.isFetchingLeave = false;
        draft.leaves = [];
        break;

      case SET_ALLOWANCE:
        draft.isSettingAllowance = true;
        break;
      case SET_ALLOWANCE_SUCCESS:
        draft.isSettingAllowance = false;
        break;
      case SET_ALLOWANCE_FAILURE:
        draft.isSettingAllowance = false;
        break;

      case DELETE_LEAVE:
        draft.isDeletingLeave = true;
        break;
      case DELETE_LEAVE_SUCCESS:
        draft.isDeletingLeave = false;
        break;
      case DELETE_LEAVE_FAILURE:
        draft.isDeletingLeave = false;
        break;

      case GET_YEARS:
        draft.isFetchingYears = true;
        draft.yearList = [];
        break;
      case GET_YEARS_SUCCESS:
        draft.isFetchingYears = false;
        draft.yearList = action.payload;
        break;
      case GET_YEARS_FAILURE:
        draft.isFetchingYears = false;
        draft.yearList = [];
        break;

      case FETCH_HISTORY:
        draft.isFetchingHistory = true;
        draft.leaveHistory = [];
        break;
      case FETCH_HISTORY_SUCCESS:
        draft.isFetchingHistory = false;
        draft.leaveHistory = action.payload;
        break;
      case FETCH_HISTORY_FAILURE:
        draft.isFetchingHistory = false;
        draft.leaveHistory = [];
        break;

      case FETCH_REQUESTS:
        draft.isFetchingReqs = true;
        draft.requestList = [];
        break;
      case FETCH_REQUESTS_SUCCESS:
        draft.isFetchingReqs = false;
        draft.requestList = action.payload;
        break;
      case FETCH_REQUESTS_FAILURE:
        draft.isFetchingReqs = false;
        draft.requestList = [];
        break;

      case APRROVE_LEAVE:
        draft.isApproving = true;
        break;
      case APRROVE_LEAVE_SUCCESS:
        draft.isApproving = false;
        break;
      case APRROVE_LEAVE_FAILURE:
        draft.isApproving = false;
        break;

      case FETCH_MONTH:
        draft.isFetchingMonth = true;
        draft.monthList = [];
        break;
      case FETCH_MONTH_SUCCESS:
        draft.isFetchingMonth = false;
        draft.monthList = action.payload;
        break;
      case FETCH_MONTH_FAILURE:
        draft.isFetchingMonth = false;
        draft.monthList = [];
        break;

      case GET_HISTORY:
        draft.isFetchingHistory = true;
        draft.singleHistory = {};
        break;
      case GET_HISTORY_SUCCESS:
        draft.isFetchingHistory = false;
        draft.singleHistory = action.payload;
        break;
      case GET_HISTORY_FAILURE:
        draft.isFetchingHistory = false;
        draft.singleHistory = {};
        break;

      case GET_HOME_LEAVES:
        draft.isFetchingHome = true;
        draft.homeLeaves = [];
        break;
      case GET_HOME_LEAVES_SUCCESS:
        draft.isFetchingHome = false;
        draft.homeLeaves = action.payload;
        break;
      case GET_HOME_LEAVES_FAILURE:
        draft.isFetchingHome = false;
        draft.homeLeaves = [];
        break;

      case UPDATE_LEAVE_EMP:
        draft.leaveEmployee = action.payload;
        break;

      case DELETE_FILE:
        draft.deletingData = action.payload;
        break;
      case DELETE_FILE_SUCCESS:
        draft.deletingData = action.payload;
        break;
      case DELETE_FILE_FAILURE:
        draft.deletingData = action.payload;
        break;

      case TOGGLE_FILE_DEL:
        draft.deleteFileConfirm = action.payload;
        break;

      case FETCH_REPORT_LIST:
        draft.isFetchingReportList = true;
        draft.reportList = [];
        break;
      case FETCH_REPORT_LIST_SUCCESS:
        draft.isFetchingReportList = false;
        draft.reportList = action.payload;
        break;
      case FETCH_REPORT_LIST_FAILURE:
        draft.isFetchingReportList = false;
        draft.reportList = [];
        break;

      case GET_ACCRUAL_LEAVE:
        draft.isFetchingAccrualLeave = true;
        break;
      case GET_ACCRUAL_LEAVE_SUCCESS:
        draft.isFetchingAccrualLeave = false;
        draft.accrualLeave = action.payload;
        break;
      case GET_ACCRUAL_LEAVE_FAILURE:
        draft.isFetchingAccrualLeave = false;
        draft.accrualLeave = {};
        break;

      case GET_ACCRUAL_PERIOD:
        draft.isFetchingAccrualPeriod = true;
        draft.accrualPeriod = {};
        break;
      case GET_ACCRUAL_PERIOD_SUCCESS:
        draft.isFetchingAccrualPeriod = false;
        draft.accrualPeriod = action.payload;
        break;
      case GET_ACCRUAL_PERIOD_FAILURE:
        draft.isFetchingAccrualPeriod = false;
        draft.accrualPeriod = {};
        break;

      case EXPORT_ACCRUAL:
        draft.isExportingAccrual = true;
        break;
      case EXPORT_ACCRUAL_SUCCESS:
        draft.isExportingAccrual = false;
        break;
      case EXPORT_ACCRUAL_FAILURE:
        draft.isExportingAccrual = false;
        break;

      case GET_AVG_HOURS:
        draft.isFetchingAvgHours = true;
        draft.avgHours = {};
        break;
      case GET_AVG_HOURS_SUCCESS:
        draft.isFetchingAvgHours = false;
        draft.avgHours = action.payload;
        break;
      case GET_AVG_HOURS_FAILURE:
        draft.isFetchingAvgHours = false;
        draft.avgHours = {};
        break;

      default:
        return state;
    }
  });

export default LeaveReducer;
